import { FiatOrderSet, FIAT_ORDER } from '@exodus/models'

const resultFunction = (visibleOrders) =>
  FiatOrderSet.fromArray(
    [...visibleOrders].filter((order) => order.exodusStatus === FIAT_ORDER.ORDER_STATUS.in_progress)
  )

const inProgressOrdersSelectorDefinition = {
  id: 'inProgressOrders',
  resultFunction,
  dependencies: [{ selector: 'visibleOrders' }],
}

export default inProgressOrdersSelectorDefinition
